const getAppRoutes = require('../router/getRoutes');
// eslint-disable-next-line no-async-promise-executor
let articlesRoutes = []
Promise.resolve(getAppRoutes.getAppRoutes).then(function (result) {
  articlesRoutes = result;
  return result;
});
module.exports = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: 'Bige digital lille France',
      metaTags: [
        {
          name: 'description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        },
        {
          property: 'og:description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        }
      ]
    },
    children: [
      {
        path: '/',
        component: () => import('@/views/about/AboutSimple.vue')
      }
    ],
    component: () => import(/* webpackChunkName: "About" */'@/views/About.vue')
  },
  {
    path: '/search',
    name: 'Search',
    meta: {
      title: 'back search route',
    },
    component: () => import(/* webpackChunkName: "search display" */'@/views/Search.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      title: 'Bige digital lille France',
      sitemap: {
        // Slugs can also be provided asynchronously
        // The callback must always return an array
        changefreq: 'monthly',
        priority: 0.7,
        slugs: ['ateliers', 'uiux', "developpement", "motion"]
      },
      metaTags: [
        {
          name: 'description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        },
        {
          property: 'og:description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        }
      ]
    },
    children: [
      {
        path: 'ateliers',
        component: () => import('@/views/about/Ateliers.vue')
      },
      {
        path: 'uiux',
        component: () => import('@/views/about/UiUx.vue')
      },
      {
        path: 'developpement',
        component: () => import('@/views/about/Dev.vue')
      },
      {
        path: 'motion',
        component: () => import('@/views/about/Motion.vue')
      }
    ],
    component: () => import(/* webpackChunkName: "About" */'@/views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: {
      title: 'Bige digital lille France',
      metaTags: [
        {
          name: 'description',
          content: 'Contacter la Bige et créer un projet !'
        },
        {
          property: 'og:description',
          content: 'Contacter la Bige et créer un projet !'
        }
      ]
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "ContactInfos" */'@/views/contact/Infos.vue')
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "ContactCreate" */'@/views/contact/Create.vue')
      }
    ],
    component: () => import(/* webpackChunkName: "Contact" */'@/views/contact/Contact.vue')
  },
  /* {
    path: '/login',
    name: 'Login',
    component: require('@/views/LoginPage.vue').default
  }, */
  {
    path: '/category/:category',
    name: 'Category articles',
    meta: {
      sitemap: {
        slugs: [
          {
            category: "technology"
          },
          {
            category: "uiux"
          },
          {
            category: "integration"
          },
          {
            category: "divers"
          }
        ]
      },
      title: 'Bige digital lille France',
      metaTags: [
        {
          name: 'description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        },
        {
          property: 'og:description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        }
      ]
    },
    component: () => import(/* webpackChunkName: "Category" */'@/views/Home.vue')
  },
  {
    path: '/feeds/',
    name: 'Articles',
    meta: {
      title: 'Bige digital lille France',
      metaTags: [
        {
          name: 'description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        },
        {
          property: 'og:description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        }
      ]
    },
    component: () => import(/* webpackChunkName: "Home Feeds" */'@/views/Home.vue')
  },
  {
    path: '/feeds/:url',
    name: 'Article Details',
    /* beforeEnter: (to, from, next) => {
      axios.get('api/...')
        .then(response => {
          store.commit('mutation', response)
          next()
        })
        .catch(e => {
          alert('Something went wrong')
          next(false)
        })
    }, */
    meta: {
      title: 'Bige digital lille France',
      sitemap: {
        // Slugs can also be provided asynchronously
        // The callback must always return an array
        changefreq: 'monthly',
        priority: 0.7,
        slugs: articlesRoutes,
      },
      metaTags: [
        {
          name: 'description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        },
        {
          property: 'og:description',
          content: 'Bige parle du numérique et digital depuis Lille Haut de france.'
        }
      ]
    },
    component: () => import(/* webpackChunkName: "Articles" */'@/views/Articles.vue')
  },
  {
    path: '/write',
    name: 'Write',
    meta: { sitemap: { ignoreRoute: true } },
    component: () => import(/* webpackChunkName: "Write" */'@/views/Write.vue')
  },
  {
    path: '/write/:id',
    name: 'Write Indexed',
    meta: { sitemap: { ignoreRoute: true } },
    component: () => import(/* webpackChunkName: "Write" */'@/views/Write.vue')
  },
  {
    path: '/documentation',
    name: 'Documentation',
    meta: {
      title: 'Bige documentation API',
      metaTags: [
        {
          name: 'description',
          content: 'Cette page contient la documentation de l\'API REST Bige.'
        },
        {
          property: 'og:description',
          content: 'Cette page contient la documentation de l\'API REST Bige.'
        }
      ]
    },
    component: () => import(/* webpackChunkName: "Documentation" */'@/views/Documentation.vue')
  },
  {
    path: '/account',
    name: 'Account',
    meta: {
      title: 'Account user',
      sitemap: { ignoreRoute: true },
      metaTags: [
        {
          name: 'description',
          content: 'Bige dev.'
        },
        {
          property: 'og:description',
          content: 'Bige dev.'
        }
      ]
    },
    component: () => import(/* webpackChunkName: "Account" */'@/views/Account.vue')
  },
  {
    path: '/cgu',
    name: 'CGU',
    meta: {
      sitemap: { ignoreRoute: false },
      title: 'Bige conditions générales d\'utilisation',
      metaTags: [
        {
          name: 'description',
          content: 'Conditions générales d\'utilisation du site Bige-start.web.app.'
        },
        {
          property: 'og:description',
          content: 'Conditions générales d\'utilisation du site Bige-start.web.app.'
        }
      ]
    },
    component: () => import(/* webpackChunkName: "CGU" */'@/views/CGU.vue')
  },
  {
    path: "*", name: '404',
    meta: {
      sitemap: { ignoreRoute: true },
      title: 'Bige page introuvable 404',
      metaTags: [
        {
          name: 'description',
          content: 'PAGE NOT FOUND'
        },
        {
          property: 'og:description',
          content: 'Page not found'
        }
      ]
    }, component: () => import(/* webpackChunkName: "404" */'@/views/404.vue')
  }
];